module.exports = __webpack_public_path__ + "img/helloKigali.edaf2c83.jpg";